import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { BreakableText } from "@design-system/BreakableText/BreakableText";

interface SplitDescriptionCellProps {
    row: { original: { bankDescription: string } };
}

export const SplitDescriptionCell = memo(
    ({ row }: SplitDescriptionCellProps) => (
        <ViewTableCell>
            <BreakableText text={row.original.bankDescription} showTooltip />
        </ViewTableCell>
    ),
);

SplitDescriptionCell.displayName = "SplitDescriptionCell";
